class ProductLowStock extends HTMLElement {
  static observedAttributes = ["inventory-quantity", "inventory-management"];
  constructor() {
    super();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;

    const quantity = this.inventoryQuantity;
    this.innerHTML = this.textForQuantity(quantity);
    this.style.display = quantity < 4 && quantity > 0 && this.inventoryManagement === 'shopify' ? null : 'none';
  }

  get inventoryQuantity() {
    return parseInt(this.getAttribute("inventory-quantity"));
  }

  get inventoryManagement() {
    return this.getAttribute("inventory-management");
  }

  textForQuantity(quantity) {
    if (quantity === 1) return this.getAttribute('one');

    return this.getAttribute('other').replace('[count]', quantity);
  }
}

if (!customElements.get("product-low-stock")) {
  customElements.define("product-low-stock", ProductLowStock);
}
